import SuperTokens from "supertokens-auth-react";
import ThirdParty, { Google } from "supertokens-auth-react/recipe/thirdparty";
import Session from "supertokens-auth-react/recipe/session";

const websiteDomain = window.location.host;

SuperTokens.init({
  appInfo: {
    appName: "outset",
    apiDomain: websiteDomain,
    websiteDomain: websiteDomain,
    apiBasePath: "/api",
    websiteBasePath: "/auth",
  },
  recipeList: [
    ThirdParty.init({
      signInAndUpFeature: {
        providers: [
          Google.init(),
        ]
      }
    }),
    Session.init()
  ]
});